export const GET_CURRENT_LAWYER = 'GET_CURRENT_LAWYER'

export default {
  is_LOADING(state) {
    return state.loading
  },
  [GET_CURRENT_LAWYER](state) {
    return state.currentLawyer
  },
}
